import React from 'react';

import { toast } from 'react-toastify';
import styled from 'styled-components';

import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryLoadingButton } from 'components/TotemPrimaryLoadingButton';
import { useDeleteMicrostoreColumnMutation } from 'data/__generated__';

export function DeleteMicrostoreColumnPopup({
    isOpen,
    microstoreColumnToDelete,
    setIsOpen,
}: {
    isOpen: boolean;
    microstoreColumnToDelete: { _id: string } | null;
    setIsOpen: (arg: boolean) => void;
}) {
    const [deleteMicrostoreColumn, { loading: creationLoading }] = useDeleteMicrostoreColumnMutation();

    if (!microstoreColumnToDelete) {
        return (
            <TotemPopup
                title="VOULEZ-VOUS VRAIMENT ARCHIVER CETTE COLONNE ?"
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                contentOverflow="visible"
            >
                <SubmitContainer>
                    <div>Il y a eu une erreur</div>
                </SubmitContainer>
            </TotemPopup>
        );
    }

    async function handleSubmit() {
        if (!microstoreColumnToDelete) {
            return;
        }

        const { data } = await deleteMicrostoreColumn({
            variables: {
                microstoreColumnId: microstoreColumnToDelete._id,
            },
        });

        if (!data) {
            throw new Error('Une erreur est survenue lors de la suppression de la colonne microstore');
        }

        const {
            deleteMicrostoreColumnMutation: { errors },
        } = data;

        if (errors.length) {
            errors.forEach((error, index) => {
                toast.error(<span key={index}>Erreur : {error}</span>, { autoClose: false });
            });

            if (errors.length > 1) {
                toast.info('Cliquez pour fermer toutes les notifications', {
                    autoClose: false,
                    onClick: () => toast.dismiss(),
                });
            }
        }

        setIsOpen(false);
    }

    return (
        <TotemPopup
            title="VOULEZ-VOUS VRAIMENT ARCHIVER CETTE COLONNE ?"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            contentOverflow="visible"
        >
            <SubmitContainer>
                <div>Attention, une fois archivée, vous ne pourrez plus consulter son contenu.</div>
                <ButtonsContainer>
                    <TotemPrimaryLoadingButton
                        loading={creationLoading}
                        onClick={() => setIsOpen(false)}
                        useIcon={false}
                        label="Annuler"
                    />
                    <TotemPrimaryLoadingButton
                        loading={creationLoading}
                        onClick={handleSubmit}
                        useIcon={false}
                        label="Confirmer"
                    />
                </ButtonsContainer>
            </SubmitContainer>
        </TotemPopup>
    );
}

const SubmitContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    color: ${({ theme }) => theme.infoTextColor};

    > :not(:first-child) {
        margin-top: 15px;
    }
`;

const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    > :not(:first-child) {
        margin-left: 50px;
    }
`;
